<div class="plan page-layout" *transloco="let t">
  <app-pap-plan-filter (filterUpdated)="setFilter($event)" (export)="exportPage($event)" (print)="printPage()"></app-pap-plan-filter>

  <ng-container *ngIf="portfolioTargetList$ | withLoader | async as portfolioTargetList">
    <div class="portfolio-activity-list page-layout-sub no-gutters">
      <div class="col table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ t('pap/plan/created') }}</th>
              <th scope="col">{{ t('pap/plan/teacher') }}</th>
              <th scope="col">{{ t('pap/plan/title') }}</th>
              <th scope="col">{{ t('pap/plan/state') }}</th>
              <th scope="col">{{ t('pap/plan/support') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="portfolioTargetList.results.length > 0; else noResults">
              <app-pap-plan-row
                *ngFor="let portfolioTarget of portfolioTargetList.results"
                [portfolioTarget]="portfolioTarget"
                (click)="openPortfolioTarget(portfolioTarget)"
              ></app-pap-plan-row>
            </ng-container>

            <ng-template #noResults>
              <tr class="no-results" height="76px">
                <td>
                  {{ t('pap/plan/noResults') }}
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="portfolioTargetList.results.length > 0"
      [(page)]="page"
      (pageChange)="onPageChange($event)"
      [collectionSize]="portfolioTargetList.count"
      [pageSize]="limit"
      [showLimitSelector]="true"
      (limitChange)="onLimitChange($event)"
    ></app-pagination>
  </ng-container>
</div>
